import { roles } from '../cassandra-shared-js/roles';
import actions from './actions';

export default [
  {
    action: actions.VIEW_HEADER_DROPDOWN,
    roles: [
      roles.ADMINISTRATOR_ROLE,
    ],
  },
  {
    action: actions.VIEW_HOME_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.DEFAULT_ADMIN_TOOL,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // // roles.MANAGEMENT_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
      roles.NUTRITION_GENETICS_USER,
      roles.THIRD_PARTY_CARDIOLOGIST,
      roles.LOGISTICS_DEPT_USER,
      roles.SALES,
      roles.MARKETING,
      roles.DIETICIAN,
      roles.LAB,
      roles.AL_MANAGER,
    ],
  },
  {
    action: actions.VIEW_CONCENTS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.DEFAULT_ADMIN_TOOL,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.VIEW_DOCTOR_KITS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.LOGISTICS_DEPT_USER,
      roles.SALES,
      roles.MARKETING,
      // roles.NUTRITION_GENETICS_USER,
    ],
  },
  {
    action: actions.VIEW_CORPORATE_KITS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.LOGISTICS_DEPT_USER,
      roles.SALES,
      roles.MARKETING,
      // roles.NUTRITION_GENETICS_USER,
    ],
  },
  {
    action: actions.VIEW_APPOINTMENTS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.QUALITY_DEPARTMENT_USER_ROLE,
      // roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      roles.NUTRITION_GENETICS_USER,
      // roles.DEFAULT_ADMIN_TOOL,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
      // roles.MARKETING,
      roles.DIETICIAN,
    ],
  },
  {
    action: actions.VIEW_THEMATIC_PACKAGE_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      // roles.QUALITY_DEPARTMENT_USER_ROLE,
      // roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
      // roles.MARKETING,
    ],
  },
  {
    action: actions.VIEW_TRAITS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
      // roles.QUALITY_DEPARTMENT_USER_ROLE,
      // roles.QUALITY_DEPARTMENT_USER_ROLE_2,
    ],
  },
  {
    action: actions.VIEW_KITS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
      roles.LOGISTICS_DEPT_USER,
      roles.SALES,
      roles.MARKETING,
    ],
  },
  {
    action: actions.VIEW_ASSOCIATION_REPORTS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
      // roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.LOGISTICS_DEPT_USER,
      // roles.SALES,
      // roles.MARKETING,
    ],
  },
  {
    action: actions.VIEW_UPGRADED_KITS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      roles.LOGISTICS_DEPT_USER,
    ],
  },
  {
    action: actions.VIEW_SNPS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
    ],
  },
  {
    action: actions.VIEW_DIAGNOSTIC_PACKAGE_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
    ],
  },
  {
    action: actions.VIEW_DOCTOR_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.SALES,
      roles.LOGISTICS_DEPT_USER,
      roles.MARKETING,
    ],
  },
  {
    action: actions.VIEW_DIAGNOSTIC_UNITS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
    ],
  },
  {
    action: actions.VIEW_B2B_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      roles.SALES,
    ],
  },
  {
    action: actions.VIEW_SERIAL_NUMBERS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      roles.LOGISTICS_DEPT_USER,
    ],
  },
  {
    action: actions.VIEW_USERS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
    ],
  },
  {
    action: actions.VIEW_REPORTS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.QUALITY_DEPARTMENT_USER_ROLE,
      // roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      // roles.LOGISTICS_DEPT_USER,
      // roles.MARKETING,
    ],
  },
  {
    action: actions.VIEW_CARDIO_REPORTS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      roles.THIRD_PARTY_CARDIOLOGIST,
      roles.LOGISTICS_DEPT_USER,
    ],
  },
  {
    action: actions.VIEW_NG_REPORTS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.QUALITY_DEPARTMENT_USER_ROLE,
      // roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      roles.LOGISTICS_DEPT_USER,
      roles.NUTRITION_GENETICS_USER,
      roles.THIRD_PARTY_CARDIOLOGIST,
    ],
  },
  {
    action: actions.VIEW_PGX_REPORTS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.THIRD_PARTY_CARDIOLOGIST,
      roles.LOGISTICS_DEPT_USER,
    ],
  },
  {
    action: actions.VIEW_BIO_AGE_REPORTS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.QUALITY_DEPARTMENT_USER_ROLE,
      // roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      roles.LOGISTICS_DEPT_USER,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      roles.THIRD_PARTY_CARDIOLOGIST,
    ],
  },
  {
    action: actions.VIEW_QUESTIONS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
      // roles.MARKETING,
    ],
  },
  {
    action: actions.VIEW_HOME_PAGE_OTHER,
    roles: [
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.VIEW_HOME_PAGE_COMMERCIAL,
    roles: [
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.CREATE_THEMATIC_PACKAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
      // roles.MARKETING,
    ],
  },
  {
    action: actions.EDIT_THEMATIC_PACKAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
      // roles.MARKETING,
    ],
  },
  {
    action: actions.DELETE_THEMATIC_PACKAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
      // roles.MARKETING,
    ],
  },
  {
    action: actions.VIEW_THEMATIC_PACKAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
      // roles.MARKETING,
    ],
  },
  {
    action: actions.VIEW_MISCELLANEOUS,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
    ],
  },
  {
    action: actions.SHOW_TRAITS,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.RESET_THEMATIC_PACKAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
      // roles.MARKETING,
    ],
  },
  {
    action: actions.SAVE_THEMATIC_PACKAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
      // roles.MARKETING,
    ],
  },
  {
    action: actions.EDIT_PRODUCT_CODE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.EDIT_DESCRIPTION,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.EDIT_NAME,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.EDIT_POPULATION_GROUP,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.EDIT_REPORT_FIELD,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
    ],
  },
  {
    action: actions.EDIT_CATEGORY,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.EDIT_THEMATIC_GROUP,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.EDIT_DEVICES,
    roles: [
      roles.ADMINISTRATOR_ROLE,
    ],
  },
  {
    action: actions.EDIT_DIAGNOSTIC_PACKAGE_FIELD,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.EDIT_APPROVAL_STATUS,
    roles: [
      roles.ADMINISTRATOR_ROLE,
    ],
  },
  {
    action: actions.EDIT_MEASUREMENT_UNIT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.EDIT_TAX,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.EDIT_ACCOUNTING_CATEGORY,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.EDIT_BARCODE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.EDIT_BUSINESS_UNIT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.EDIT_WHOLESALE_PRICE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.COMMERCIAL_DEPARTMENT_USER_ROLE_USER_ROLE,
    ],
  },
  {
    action: actions.EDIT_RETAIL_PRICE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.RUN_EDAG,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.ADD_TRAIT_TO_THEMATIC_PACKAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // roles.MARKETING,
    ],
  },
  {
    action: actions.DELETE_TRAIT_FROM_THEMATIC_PACKAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // roles.MARKETING,
    ],
  },
  {
    action: actions.SHOW_TRAIT_SNPS,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.ADD_SNP_TO_TRAIT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
    ],
  },
  {
    action: actions.DELETE_SNP_FROM_TRAIT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
    ],
  },
  {
    action: actions.CREATE_TRAIT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
    ],
  },
  {
    action: actions.EDIT_TRAIT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
    ],
  },
  {
    action: actions.DELETE_TRAIT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
    ],
  },
  {
    action: actions.VIEW_TRAIT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.CREATE_SNP,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
    ],
  },
  {
    action: actions.EDIT_SNP,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
    ],
  },
  {
    action: actions.DELETE_SNP,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
    ],
  },
  {
    action: actions.VIEW_SNP,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.CREATE_DIAGNOSTIC_PACKAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.EDIT_DIAGNOSTIC_PACKAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.DELETE_DIAGNOSTIC_PACKAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.VIEW_DIAGNOSTIC_PACKAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.CREATE_DOCTOR,
    roles: [
      roles.ADMINISTRATOR_ROLE,
    ],
  },
  {
    action: actions.EDIT_DOCTOR,
    roles: [
      roles.ADMINISTRATOR_ROLE,
    ],
  },
  {
    action: actions.DELETE_DOCTOR,
    roles: [
      roles.ADMINISTRATOR_ROLE,
    ],
  },
  {
    action: actions.VIEW_DOCTOR,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
    ],
  },
  {
    action: actions.CREATE_DIAGNOSTIC_UNIT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
    ],
  },
  {
    action: actions.EDIT_DIAGNOSTIC_UNIT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
    ],
  },
  {
    action: actions.DELETE_DIAGNOSTIC_UNIT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
    ],
  },
  {
    action: actions.VIEW_DIAGNOSTIC_UNIT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
    ],
  },
  {
    action: actions.CREATE_B2B,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.EDIT_B2B,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.DELETE_B2B,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.VIEW_B2B,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
    ],
  },
  {
    action: actions.CREATE_REPORT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.EDIT_REPORT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.DELETE_REPORT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.VIEW_REPORT,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
    ],
  },
  {
    action: actions.CREATE_QUESTIONNAIRE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.EDIT_QUESTIONNAIRE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.DELETE_QUESTIONNAIRE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.VIEW_QUESTIONNAIRE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      // roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
      // roles.MANAGEMENT_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
      // // roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      // roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
  },
  {
    action: actions.GENERAL_REPORT_FINALIZE_EDIT,
    roles: [
      roles.THIRD_PARTY_CARDIOLOGIST,
      roles.NUTRITION_GENETICS_USER,
    ],
  },
  {
    action: actions.THIRD_PARTY_REPORT_FINALIZE_EDIT,
    roles: [
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
    ],
  },
  {
    action: actions.ANALYTICS_REPORT_FINALIZE_EDIT,
    roles: [
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.GENERAL_REPORT_FINALIZE_VIEW,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.THIRD_PARTY_CARDIOLOGIST,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      roles.NUTRITION_GENETICS_USER,
    ],
  },
  {
    action: actions.THIRD_PARTY_REPORT_FINALIZE_VIEW,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.ANALYTICS_REPORT_FINALIZE_VIEW,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
    ],
  },
  {
    action: actions.VIEW_3IN1_REPORTS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.NUTRITION_GENETICS_USER,
      roles.THIRD_PARTY_CARDIOLOGIST,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      roles.LOGISTICS_DEPT_USER,
    ],
  },
  {
    action: actions.VIEW_NUTRITION_REPORTS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.NUTRITION_GENETICS_USER,
      roles.THIRD_PARTY_CARDIOLOGIST,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      roles.LOGISTICS_DEPT_USER,
    ],
  },
  {
    action: actions.VIEW_VITAMINS_REPORTS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.NUTRITION_GENETICS_USER,
      roles.THIRD_PARTY_CARDIOLOGIST,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      roles.LOGISTICS_DEPT_USER,
    ],
  },
  {
    action: actions.VIEW_EXTRA_FIELDS_OTHER_REPORTS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
    ],
  },
  {
    action: actions.VIEW_EMAIL_TEMPLATES_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
    ],
  },
  {
    action: actions.VIEW_TRANSLATIONS_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
    ],
  },
  {
    action: actions.VIEW_PROMO_CODES_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
    ],
  },
  {
    action: actions.VIEW_BUSINESS_MANAGEMENT_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.SALES,
    ],
  },
  {
    action: actions.VIEW_MANAGEMENT_MENU,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.SALES,

    ],
  },
  {
    action: actions.VIEW_REPORTS_MENU,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      roles.THIRD_PARTY_CARDIOLOGIST,
      roles.LOGISTICS_DEPT_USER,
      roles.NUTRITION_GENETICS_USER,
    ],
  },
  {
    action: actions.VIEW_MISCELLANEOUS_MENU,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
      roles.LOGISTICS_DEPT_USER,
      // roles.QUALITY_DEPARTMENT_USER_ROLE,
      // roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      // roles.MARKETING,
      // roles.LOGISTICS_DEPT_USER,
      // roles.SALES,
    ],
  },
  {
    action: actions.VIEW_TOOLS_MENU,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.NUTRITION_GENETICS_USER,
      roles.DIETICIAN,
      // roles.MARKETING,
    ],

  },
  {
    action: actions.VIEW_REGISTRATION_MENU,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.LOGISTICS_DEPT_USER,
      roles.SALES,
      roles.MARKETING,
      // roles.NUTRITION_GENETICS_USER,
    ],
  },
  {
    action: actions.VIEW_SERIAL_MENU,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.LOGISTICS_DEPT_USER,
    ],
  },
  {
    action: actions.VIEW_LAB_MENU,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      roles.LAB,
    ],
  },
  {
    action: actions.VIEW_LAB_FILES_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      roles.LAB,
    ],
  },
  {
    action: actions.VIEW_LAB_SAMPLES_PAGE,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE_2,
      roles.LAB,
    ],
  },
  {
    action: actions.VIEW_MANAGER_MENU,
    roles: [
      roles.ADMINISTRATOR_ROLE,
      roles.AL_MANAGER,
    ],
  },
];

